import * as React from "react";
import { Context } from "./_context";
export const ClearFieldIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 7.94L9.53 8.47 8.47 9.53 10.94 12l-2.47 2.47 1.06 1.06L12 13.06l2.47 2.47 1.06-1.06L13.06 12l2.47-2.47-1.06-1.06L12 10.94Z", fill: "currentColor" }));
  return iconset[size];
};
ClearFieldIcon.iconId = "yVFZCs";
